/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import * as _redux from "../redux";

import { AuthPage, Logout } from "./modules/Auth";
import React, { useState } from "react";
import { Navigate, Route, Routes as RouterRoutes, useNavigate } from "react-router";
import { shallowEqual, useSelector } from "react-redux";

import BasePage from "./BasePage";
import CheckoutPage from "./pages/CheckoutPage";
import ResetPassword from "./modules/Auth/pages/ResetPassword";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { Layout } from "../_metronic/layout";
import SnackBarTool from "../_metronic/_partials/widgets/snack-bar/SnackBar";
import axios from "axios";

/**
 * Layout wrapper for public checkout pages.
 * @param {{ children: React.ReactNode }} props
 * @returns {JSX.Element}
 */
const CheckoutLayout = ({ children }) => (
  <div className="d-flex flex-column flex-root">
    <div className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">
      <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
        <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
          {children}
        </div>
      </div>
    </div>
  </div>
);

/**
 * Top-level application router that handles auth-gated and public routes.
 * Checkout routes are rendered outside the auth gate so they remain accessible
 * regardless of the user's login state.
 * @returns {JSX.Element}
 */
export function Routes() {
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });

  const { isAuthorized } = useSelector(
    ({ auth, order }) => ({
      isAuthorized: auth.user != null,
      charge: order.carDetail,
    }),
    shallowEqual
  );

  const navigate = useNavigate();
  _redux.setupAxiosResponse(axios, navigate, setSnack);

  return (
    <>
      <RouterRoutes>
        <Route
          path="/checkout/*"
          element={<CheckoutLayout><CheckoutPage /></CheckoutLayout>}
        />
        <Route
          path="/bac-checkout/*"
          element={<CheckoutLayout><CheckoutPage /></CheckoutLayout>}
        />
        <Route
          path="/password/reset/:id"
          element={<CheckoutLayout><ResetPassword /></CheckoutLayout>}
        />
        <Route path="/error/*" element={<ErrorsPage />} />
        <Route path="/logout" element={<Logout />} />

        {isAuthorized ? (
          <Route path="/auth/*" element={<Navigate to="/" replace />} />
        ) : (
          <Route path="/auth/*" element={<AuthPage />} />
        )}

        {isAuthorized ? (
          <Route path="/*" element={<Layout><BasePage /></Layout>} />
        ) : (
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        )}
      </RouterRoutes>
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </>
  );
}
